import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";
import ToggleSwitch from "components/ToggleSwitch/ToggleSwitch";
import styles from "./Notifications.module.css";

export default function Notifications() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser?.id;
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [switches, setSwitches] = useState({
    switch1: false, switch2: false, switch3: false, switch4: false,
  });

  const toggleSwitch = (name) => setSwitches(prev => ({ ...prev, [name]: !prev[name] }));

  useEffect(() => {
    if (!id) { setLoading(false); return; }
    AuthService.fetchNotification(id)
      .then(r => setNotifs(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="content mid-content">
      <div className={styles.welcome}>
        <h2 className={styles.welcomeTitle}>Notifications</h2>
        <p className={styles.welcomeSub}>Manage your notification preferences and history</p>
      </div>

      {/* Preferences */}
      <div className={styles.card}>
        <div className={styles.cardHeader}>Notification Preferences</div>
        <div className={styles.cardBody}>
          {[
            { key: 'switch1', label: 'General Notifications' },
            { key: 'switch2', label: 'Transaction Notifications' },
            { key: 'switch3', label: 'Product Updates' },
            { key: 'switch4', label: 'Email Notifications' },
          ].map(({ key, label }) => (
            <div key={key} className={styles.prefRow}>
              <span>{label}</span>
              <ToggleSwitch isOn={switches[key]} toggleSwitch={() => toggleSwitch(key)} />
            </div>
          ))}
        </div>
      </div>

      {/* History */}
      <div className={styles.card} style={{ marginTop: '1.5rem' }}>
        <div className={styles.cardHeader}>Recent Notifications</div>
        <div className={styles.cardBody}>
          {loading ? (
            [1,2,3].map(i => <div key={i} className={styles.skel} style={{ height: 40, marginBottom: 8 }} />)
          ) : notifs.length === 0 ? (
            <div className={styles.empty}>No notifications yet</div>
          ) : (
            notifs.map(n => (
              <div key={n.id} className={styles.notifItem}>
                <div className={styles.notifDot} style={{ background: n.read ? 'var(--border-light)' : 'var(--accent)' }} />
                <div className={styles.notifContent}>
                  <div className={styles.notifTitle}>{n.title}</div>
                  <div className={styles.notifMsg}>{n.message}</div>
                </div>
                <div className={styles.notifDate}>{new Date(n.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}